// extracted by mini-css-extract-plugin
export var actions = "styles-module--actions--82e55";
export var brand = "styles-module--brand--0b69d";
export var contactCard = "styles-module--contactCard--dbd8d";
export var container = "styles-module--container--c98a6";
export var dept = "styles-module--dept--fe168";
export var details = "styles-module--details--23c62";
export var fullName = "styles-module--fullName--709a7";
export var position = "styles-module--position--fb9d3";
export var profileImage = "styles-module--profileImage--6b7cb";
export var staff_grid = "styles-module--staff_grid--742cd";